import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Utils from '../../misc/Utils';
// import Enums from '../../misc/Enums';
import axios from 'axios';
import { Table, Modal, Breadcrumb, Row, Col, Tag, Typography, Space, Tooltip, Upload, Image, Progress, Button, Divider, Checkbox, Input, Popconfirm } from 'antd';
import DocumentViewer from '../../components/document-viewer/DocumentViewer';
import { CloudUploadOutlined, EyeOutlined } from '@ant-design/icons';
import ProcessingModal from '../../components/processing/ProcessingModal';
import { Label } from 'theme-ui';

export function ReviewMER() {
   const navigate = useNavigate();

   const search = window.location.search;
   const query = new URLSearchParams(search);
   const user_id = query.get('id');

   const [saID, setSaID] = useState(null);
   const [merCompeleted, setMerCompleted] = useState(false);

   const [merList, setMerList] = useState(null);
   const [merData, setMerData] = useState({
      id: null,
      label: null,
      document: null
   });

   const [modalVisible, setModalVisible] = useState(false);
   const [reUpload, setReUpload] = useState(false);

   const [isLoading, setIsLoading] = useState(false);
   const [updating, setUpdating] = useState(false);

   const [remarks, setRemarks] = useState(null);

   useEffect(() => {
      Utils.verifyJwt();

      GetMER(user_id);
   }, [user_id]);

   const columns = [
      {
         title: 'Documents',
         key: 'label',
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Typography.Text>
               {
                  payload.label
               }
            </Typography.Text>
         ),
         width: '40%'
      },
      {
         title: 'Status',
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Typography.Text>
               {
                  payload.status !== null && payload.status !== '' &&
                  <Tag color={payload.status === 'Uploaded' || payload.status === 'Re-uploaded' ? 'green' : 'red'}>
                     {payload.status}
                  </Tag>
               }
            </Typography.Text>
         ),
         width: '10%'
      },
      {
         title: 'Remarks',
         key: 'label',
         ellipsis: {
            showTitle: false,
         },
         className: 'drag-visible',
         render: payload => (
            <Typography.Text>
               {
                  payload.remarks
               }
            </Typography.Text>
         ),
         width: '40%'
      },
      {
         title: 'Action',
         key: 'action',
         className: 'drag-visible',
         render: payload => {
            return <>
               <Space size="small">
                  {
                     payload.document !== null && payload.document !== '' &&
                     <Tooltip placement="top" title={'Preview ' + payload.label}>
                        <EyeOutlined color='#033D89' style={{ cursor: 'pointer' }}
                           onClick={() => handlePreview(payload.id, payload.label, payload.document)}
                        />
                     </Tooltip>
                  }
               </Space>
            </>
         },
         width: '20%'
      },
   ].filter(item => !item.hidden);

   const GetMER = (id) => {
      setIsLoading(true);

      axios.get(`${process.env.REACT_APP_API_CPH}/getmer?id=${id}`).then((response) => {
         if (response.data) {
            setIsLoading(false);

            const data = response.data;

            if (data !== null && data !== "") {
               setMerList(JSON.parse(data[0].mer));
               setSaID(data[0].id);
               setMerCompleted(data[0].mer_complete);
            }
         }
      }, (error) => {
         console.log(error.message);
         setIsLoading(false);
      });
   }

   const handlePreview = (id, label, document) => {
      setMerData({ id, label, document });
      setModalVisible(true);
   }

   const handleMarkComplete = () => {
      //-- Check if there are no for re-uploads before marking as complete

      var result = merList.filter(obj => {
         return obj.required && (obj.status === "Re-upload" || obj.status === "");
      });

      if (result.length === 0) {
         setUpdating(true);

         const url = `${process.env.REACT_APP_API_CPH}/markmercomplete?id=${saID}`;
         axios.post(url).then((response) => {
            if (response.data) {
               setUpdating(false);

               const data = response.data;

               if (data !== null && data !== "") {
                  setMerCompleted(true);
               }
            }
         }, (error) => {
            console.log(error.message);
            setUpdating(false);
         });
      } else {
         Modal.info({
            title: 'Online Application',
            content: 'Process cannot be completed. There are still incomplete items.',
            centered: true
         });
      }
   }

   const handleChkReupload = (e) => {
      setReUpload(e.target.checked);
   }

   const handleMERCancel = () => {
      setReUpload(false);
      setModalVisible(false);
   }

   const handleSave = () => {
      if (remarks !== null) {
         setUpdating(true);

         const mer = merList.map(item => {
            if (item.id === merData.id) {
               item.status = 'Re-upload';
               item.remarks = remarks;
            }
            return item;
         });

         var url = `${process.env.REACT_APP_API_CPH}/updatemer?id=${saID}`;
         axios.post(url, mer).then((response) => {
            if (response.data) {
               setMerList(mer);

               Modal.success({
                  title: 'Online Application',
                  content: 'Update successfull.',
                  centered: true,
               });

               setUpdating(false);
            }
         }, (error) => {
            setUpdating(false);

            Modal.error({
               title: 'Online Application',
               content: error.response.data,
               centered: true
            });
         });

         setModalVisible(false);
      }
   }

   const handleSaveStatus = (status) => {
      setUpdating(true);

      var url = `${process.env.REACT_APP_API_CPH}/updatesafield?id=${saID}&fn=application_status&fv=${status}`;
      axios.post(url).then((response) => {
         if (response.data) {
            setMerList();

            Modal.success({
               title: 'Online Application',
               content: 'Update successfull.',
               centered: true,
            });

            setUpdating(false);
         }
      }, (error) => {
         setUpdating(false);

         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });

   }

   return (
      <>
         <ProcessingModal
            processing={updating}
            title={'Brainee LMS'}
         />
         <div className="dashboard-area-all">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <ul>
                     <li className="active"><a href="#" onClick={() => navigate('/applicantlist')}>Student Applicants</a></li>
                     <li><span>/</span></li>
                     <li className="active">Review Medical Exam Result</li>
                  </ul>
               </div>
            </div>

            <Row gutter={12} style={{ overflow: "auto" }} >
               <Col span={24}>
                  {
                     merList !== null &&
                     <div className="dashboard-item-inner3">
                        <Table
                           rowKey={'student-list'}
                           loading={isLoading}
                           size='small'
                           columns={columns}
                           dataSource={merList}
                           pagination={false}
                           scroll={{
                              y: 'calc(100svh - 13.8rem)',
                              x: '1000px'
                           }}
                           // footer={() => 'Total Records: ' + merList.length}
                           footer={() =>
                              <Row>
                                 <Col span={12}>{'Total Records: ' + merList.length}</Col>
                                 <Col span={12} style={{ textAlign: 'right' }}>
                                    {/* <Button className='button-shadow' shape='round' type='primary' onClick={() => handleMarkComplete()} disabled={merCompeleted}>{merCompeleted ? "Completed" : "Mark as Complete"}</Button>&nbsp;&nbsp;&nbsp; */}
                                    <Space>
                                       <Popconfirm
                                          title="Do you want to set the medical results status to passed?"
                                          onConfirm={() => handleSaveStatus('medical_passed')}
                                          okText="Yes"
                                          cancelText="No"
                                       >
                                          <Button className='button-shadow' type='primary' shape='round'>Passed</Button>
                                       </Popconfirm>

                                       <Popconfirm
                                          title="Do you want to set the medical results status to passed with condition?"
                                          onConfirm={() => handleSaveStatus('medical_passed_with_condition')}
                                          okText="Yes"
                                          cancelText="No"
                                       >
                                          <Button className='button-shadow' type='primary' shape='round'>Passed with condition</Button>
                                       </Popconfirm>

                                       <Popconfirm
                                          title="Do you want to set the medical results status to failed?"
                                          onConfirm={() => handleSaveStatus('medical_failed')}
                                          okText="Yes"
                                          cancelText="No"
                                       >
                                          <Button className='button-shadow' type='primary' shape='round'>Failed</Button>
                                       </Popconfirm>
                                    </Space>
                                 </Col>
                              </Row>
                           }
                        />
                     </div>
                  }

               </Col>
            </Row>
         </div>

         <Modal
            key='preview-mer'
            title={"Preview " + merData.label}
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round" }}
            centered
            destroyOnClose={true}
            open={modalVisible}
            width='75%'
            onCancel={() => handleMERCancel()}
            onOk={() => handleMERCancel()}
            footer={[
               <Row>
                  <Col span={16} style={{ textAlign: 'left' }}>
                     <Space style={{ width: "100%", display: "flex" }}>
                        <Checkbox onChange={handleChkReupload}>Re-upload</Checkbox>
                        {
                           reUpload &&
                           <>
                              <Typography.Text>Remarks </Typography.Text>
                              <Input
                                 size='large'
                                 placeholder='Enter Remarks'
                                 style={{ width: "400px", borderRadius: "7px" }}
                                 onChange={e => setRemarks(e.target.value)}
                              />
                           </>
                        }
                     </Space>
                  </Col>
                  <Col span={8} style={{ textAlign: 'right' }}>
                     <Button key="save" type='primary' shape='round' onClick={() => handleSave()}>Submit</Button>
                     <Button key="close" type="primary" shape='round' onClick={() => handleMERCancel()}>Cancel</Button>
                  </Col>
               </Row>,
            ]}
         >
            <div className='student_list_container'>
               <DocumentViewer
                  document={merData.document}
                  pdfshowdownload={true}
                  pdfshowprint={true}
                  ismodal={true}
                  dvheight={"calc(100vh - 220px)"}
               />
            </div>
         </Modal>
      </>
   );
}